import * as yup from "yup";

export const incidentCommonSchema = yup.object({
  typeIncident: yup.object().required().nullable(),
  libelle: yup.string().required(),
  lieu: yup.string().required(),
});
